import ViewAbsenceCtrl from '../ViewAbsenceCtrl';

import modalViewUrl from './absenceView.html';

export default {
  templateUrl: modalViewUrl,
  controller: ViewAbsenceCtrl,
  controllerAs: 'ctrl',
  bindings: {
    event: '=',
    modal: '=',
  },
};
